// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuantityControls_quantity-controls__IW7L- {
  border: 1px solid var(--primary-color);
  border-radius: 0.8rem;
  background-color: var(--white-semi-light);
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: space-between;
  gap: 2.4rem;
  min-width: 12rem;
}

.QuantityControls_quantity-controls__quantity__g0DJX {
  color: var(--primary-color);
  font-size: var(--text-sm);
  font-weight: 500;
}

.QuantityControls_quantity-controls__btn__KMxOl {
  padding: 0;
  min-width: 3rem;
  height: 3rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/QuantityControls/QuantityControls.module.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,YAAY;AACd","sourcesContent":[".quantity-controls {\n  border: 1px solid var(--primary-color);\n  border-radius: 0.8rem;\n  background-color: var(--white-semi-light);\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  justify-content: space-between;\n  gap: 2.4rem;\n  min-width: 12rem;\n}\n\n.quantity-controls__quantity {\n  color: var(--primary-color);\n  font-size: var(--text-sm);\n  font-weight: 500;\n}\n\n.quantity-controls__btn {\n  padding: 0;\n  min-width: 3rem;\n  height: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quantity-controls": `QuantityControls_quantity-controls__IW7L-`,
	"quantity-controls__quantity": `QuantityControls_quantity-controls__quantity__g0DJX`,
	"quantity-controls__btn": `QuantityControls_quantity-controls__btn__KMxOl`
};
export default ___CSS_LOADER_EXPORT___;
